import { useState } from "react";
import STCfinderSearchCard from "./Components/STCfinderSearchCard/STCfinderSearchCard";
import { getSTCfinderResults } from "./api/getSTCfinderResults";
import { type STCauttoSuggestData, type STCfinderMountData, type TypeSTCfinderSingleResult } from "./STCfinderTypes";
import STCfinderTabularView from "./Components/STCfinderTabularView/STCfinderTabularView";
import Spinner from "../common/components/Spinner/Spinner";
import { transformMountData } from "./STCfinderTransformers";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import { useIsMinDesktopSize } from "../common/hooks/useMediaQuery";
import { useTranslation } from "react-i18next";

interface Props {
  mountData: STCfinderMountData;
}
const STCfinder = (props: Props) => {
  const { t } = useTranslation();
  const { mountData } = props;
  const [resultsList, setResultsList] = useState<TypeSTCfinderSingleResult[]>([]);
  const [statesList, setStatesList] = useState<STCauttoSuggestData[]>([]);
  const [resultsLoading, setResultsLoading] = useState<boolean>();

  const isDesktop = useIsMinDesktopSize();

  const handleSearch = (country?: string, state?: string, zipCode?: string) => {
    setResultsLoading(true);
    getSTCfinderResults(country, state, zipCode).then((response) => {
      setResultsList(response.results);
      setStatesList(response.states);
      setResultsLoading(false);
    });
  };

  const resultAmount = (
    <p className="scha__stc-finder__results__title">
      {t("STCfinder.numberOfContacts", { number: resultsList.length })}
    </p>
  );

  return (
    <div className="stc-finder">
      <PageTitle title={t("STCfinder.title")} />
      <p className="scha__stc-finder__subtitle">{t("STCfinder.description")}</p>
      {isDesktop && resultAmount}

      <div>
        <STCfinderSearchCard
          countries={mountData.countries}
          states={statesList}
          searchResults={(country, state, zipCode) => handleSearch(country, state, zipCode)}
          pageCode={mountData.pageCode}
        />
        {!isDesktop && resultAmount}
        {resultsLoading ? <Spinner /> : <STCfinderTabularView resultsList={resultsList} />}
      </div>
    </div>
  );
};

export function createSTCfinderPage(data: string) {
  const parsedData = JSON.parse(data);
  return <STCfinder mountData={transformMountData(parsedData)} />;
}
